import { render } from "./Hero.vue?vue&type=template&id=0712a9a5&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=0712a9a5&scoped=true&lang=scss"

import exportComponent from "/Users/pepijnvdk/TNT/wewantyou/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0712a9a5"]])

export default __exports__